<template>
<div>
    <p class="tit">
        {{project.project_name}}
        <!-- {{ subject.subject_name }} -->
    </p>
    <p class="comput">机位号：<label>001</label></p>
    <div class="content">
        <div class="login">
            <div class="opac"></div>
            <div class="login_in">
                <p class="tip">
                    温馨提示：请仔细核对个人信息，如有错误请联系监考人员！
                </p>
                <div class="mess">
                    <img src="@/assets/image/message/tou.png" width="95" height="126">
                    <div>
                        <p><label>准考证号：</label><span>{{user.exam_no || '111111111111111'}}</span></p>
                        <p><label>姓&emsp;&emsp;名：</label><span>{{user.user_name||'XXX'}}</span></p>
                        <p><label>性&emsp;&emsp;别：</label><span>{{user.sex||'X'}}</span></p>
                        <p><label>考试科目：</label><span>{{subject.subject_name || 'XXXX'}}</span></p>
                        <p><label>证件号码：</label><span>{{user.user_id_no || '111111111111111111'}}</span></p>
                        <!--<p><label>报名序号：</label><span>{{user.user_signup_no || 'XXXXXXXXX'}}</span></p>-->
                        <p><label>座&ensp;位&ensp;号：</label><span>001</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="btn">
        <input type="button" value="确认登录" class="sub" id="mybtn" @click="login">
        <input type="button" value="返回" id="back_btn" @click="back">
    </div>

</div>
</template>

<script>
export default {
    name: 'message',
    components: {},
    data() {
        return {

        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        subject() {
            return this.$store.state.exam.cur_subject;
        },
        project(){
            return this.$store.state.project;
        }
    },
    methods: {
        login() {
            this.$router.push({name: "Article",params:{project_code:this.$store.state.project.project_code}});
        },
        back() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang='scss' scoped src="../assets/css/login.scss"></style>
<style lang='scss' scoped src="../assets/css/message.scss"></style>
